import * as React from "react";

const SvgIcnDashboardsBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M6.985 13.17a.3.3 0 01.424 0l2.12 2.118a1.3 1.3 0 001.838 0l4.638-4.639v1.869a.5.5 0 101 0V9.5a.5.5 0 00-.5-.5H13.49a.5.5 0 000 1h1.749l-4.58 4.58a.3.3 0 01-.424 0l-2.118-2.118a1.3 1.3 0 00-1.839 0L4 14.74V6a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2v-1.994z"
        />
    </svg>
);

export default SvgIcnDashboardsBold;
